module.exports = __webpack_public_path__ + "img/Icon-Cancel-Filled.8d9d0e4a.svg";